import { timeInterval as o } from "./interval.js";
import { durationWeek as s, durationMinute as u } from "./duration.js";
function n(a) {
  return o((e) => {
    e.setDate(e.getDate() - (e.getDay() + 7 - a) % 7), e.setHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setDate(e.getDate() + t * 7);
  }, (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * u) / s);
}
const c = n(0), g = n(1), i = n(2), y = n(3), m = n(4), T = n(5), d = n(6);
c.range;
g.range;
i.range;
y.range;
m.range;
T.range;
d.range;
function r(a) {
  return o((e) => {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - a) % 7), e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCDate(e.getUTCDate() + t * 7);
  }, (e, t) => (t - e) / s);
}
const D = r(0), f = r(1), C = r(2), U = r(3), W = r(4), S = r(5), k = r(6);
D.range;
f.range;
C.range;
U.range;
W.range;
S.range;
k.range;
export {
  T as timeFriday,
  g as timeMonday,
  d as timeSaturday,
  c as timeSunday,
  m as timeThursday,
  i as timeTuesday,
  y as timeWednesday,
  S as utcFriday,
  f as utcMonday,
  k as utcSaturday,
  D as utcSunday,
  W as utcThursday,
  C as utcTuesday,
  U as utcWednesday
};
